import type { CarrefourReferentialIntervalType } from '@carrefour-gcs/shared';
import type { InjectionKey, Ref } from 'vue';

/** Option value standing for "custom range", next to the preset period keys. */
export const PERIOD_CUSTOM_OPTION = 'custom';

/**
 * Which Carrefour referential interval a page works with (`standard`, or `competitorVision`
 * with its blackout).
 */
export const CARREFOUR_REFERENTIAL_INTERVAL_KEY: InjectionKey<Ref<keyof CarrefourReferentialIntervalType>> = Symbol(
  'carrefourReferentialIntervalKey'
);
